module.exports = __webpack_public_path__ + "img/hzico_10.038e6356.jpg";